import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ProjectStatus" }
const _hoisted_2 = {
  key: 0,
  class: "ProjectStatus__label"
}
const _hoisted_3 = { class: "ProjectStatus__text" }

import { computed, PropType } from "vue";
import { Project } from "@/types";
import { getStatusById } from "@/tools/status";
import ProjectCardTools from "@/components/pages/projects/card/ProjectCardTools.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectStatus',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const status = computed(() => {
    return getStatusById(props.project.projectStatus);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (status.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "ProjectStatus__icon",
            style: _normalizeStyle({ '--color': status.value.color })
          }, null, 4),
          _createElementVNode("div", _hoisted_3, _toDisplayString(status.value.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(ProjectCardTools, {
      project: __props.project,
      "no-update": ""
    }, null, 8, ["project"])
  ]))
}
}

})